{
	"title": "Accès refusé (403)",
	"description": "Vous ne disposez pas des droits nécessaires pour accéder à cette page. Veuillez vous assurer que vous êtes connecté à un compte disposant des autorisations appropriées. Effacer les données de votre navigateur peut également résoudre le problème. Si vous avez toujours besoin d’accès, veuillez contacter l’administrateur système.",
	"secondaryButtonTitle": "Déconnexion"
}
